import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig } from '@/src/lib/react-query/react-query';

const url = `${PREFIX_URL}/legal-center/consents`;

type UpdateLegalConsentResponse = { status: boolean };

export const updateLegalConsent = (params: {
  consents: {
    termsAndConditions?: boolean;
    privacyPolicy?: boolean;
    newsletter?: boolean;
    cookies?: boolean;
  };
}): Promise<UpdateLegalConsentResponse> => {
  return axios.post(url, params);
};

type UseUpdateLegalConsentOptions = {
  config?: MutationConfig<typeof updateLegalConsent>;
};

export const useUpdateLegalConsent = ({ config }: UseUpdateLegalConsentOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: (params) => updateLegalConsent(params),
  });
};
